// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__2-zlA","alert":"SettungsInbox_alert__299r3"};